import { mapFilterQueryParams } from './map-filter-query-params'

export const getMappedFilterQueryParams = (
  getFilterQueryParams: () => {
    basicFilterParams: RegExpMatchArray | null
    needsBasedFilterParams: RegExpMatchArray | null
    filterCategory: RegExpMatchArray | null
  },
  getQueryParamValue: (param: string) => RegExpMatchArray | null
) => {
  const {
    basicFilterDataFromQueryParams,
    needsBasedQueryValuesFromQueryParams,
    needsBasedFilterDataFromQueryParams,
    needsBasedOptionsFromQueryParams,
    needsBasedLabelsFromQueryParams,
    needsBasedSelectedMapFromQueryParams,
  } = mapFilterQueryParams(getFilterQueryParams, getQueryParamValue)

  return {
    basicFilterDataFromQueryParams,
    needsBasedQueryValuesFromQueryParams,
    needsBasedFilterDataFromQueryParams,
    needsBasedOptionsFromQueryParams,
    needsBasedLabelsFromQueryParams,
    needsBasedSelectedMapFromQueryParams,
  }
}
